import React, { Fragment } from "react"
import { Provider } from "react-redux"
import DatatableContext from "../components/Datatable/DatatableContext"
import { store } from "../redux/store"
import InfoCardProvider from "./InfoCardProvider"
import { SnackbarProvider } from "notistack"
import ModalProvider from "./ModalProvider"
import RootErrorBoundary from "../ErrorBoundaries/RootErrorBoundary"
import LocalizationProvider from "./LocalizationProvider"

function AppProvider({ children }) {
    return (
        <Fragment>
            <LocalizationProvider>
                <RootErrorBoundary>
                    <Provider store={store}>
                        <ModalProvider>
                            <SnackbarProvider>
                                <InfoCardProvider>
                                    <DatatableContext>{children}</DatatableContext>
                                </InfoCardProvider>
                            </SnackbarProvider>
                        </ModalProvider>
                    </Provider>
                </RootErrorBoundary>
            </LocalizationProvider>
        </Fragment>
    )
}

export default AppProvider
